import { resetPassword } from './PasswordService';
import {extractError} from '../../api/ErrorUtil';

export const passwdResetFormDataInitialState = {
    originalPassword: "",
    newPassword: "",
    verifyNewPassword: "",
    errors: {},
    successmessage: [],
    infoMessage:'',
    loading:false,
    success: false
  }
  
  export const AsyncResetPasswordDataHandlers = {
    FORM_SUBMIT: ({ dispatch, getState, signal }) => async (action) => {
      let { formData } = action.payload;
      dispatch({ type: 'FORM_SUBMITTING'});
      try{
        let resetPasswordResponse = await resetPassword(formData);
        dispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: resetPasswordResponse});
      } catch (error){
        let errorMsg = extractError(error);
        dispatch({ type: 'FORM_SUBMIT_FAIL', payload: {error: errorMsg}});  
      }
    
    }
  };

  export const PasswordResetDataReducer = (state, action) => {  
    if (action.type === 'FIELD_CLEAR') {
      return passwdResetFormDataInitialState;
    }

    if (action.type === 'FORM_SUBMITTING') {
      
      return {
        ...state,
        readOnly: true,
        status: "Submitting Form...",
        infoMessage:'',
        errors: {},
        loading:true
      }
    }
  
    if (action.type === 'FORM_SUBMIT_SUCCESS') {
      let data =action.payload;
      let newState = {
        ...state,
        readOnly:false,
        infoMessage: data.message,
        errors:{},
        loading:false,
        success: true
      };
      return newState;
    }
  
    if (action.type === 'FORM_SUBMIT_FAIL') {
      let {error}  = action.payload;
      let newState = {
        ...state,
        errors: error,
        loading:false,
        success: false
      };
      return newState;
    }
  
    //the following is for form edit and hence there should be a payload.
    //otherwise just return state
  
    if (!action.payload) {
      return state;
    }
    if (action.type === 'FIELD_EDIT') {
      const { name, value } = action.payload;
      let newState = {
        ...state,
        [name]: value  
      };
      return newState;
    }
  }
  